import { FlowAuthType } from "../enums/FlowAuthType";
import { StreamGrouping } from "../enums/StreamGrouping";

export const useDummyFlowStreams = false;

export const flowStreams = [
    {
        id: 1,
        flow_provider: {
            id: 1,
            name: "Storehub POS",
            short_name: "storehub",
            authentication: FlowAuthType.HTTP_BASIC,
            // fee_types: [
            //     {
            //         id: 1,
            //         name: "Sales",
            //         description: null,
            //         nature: "INCOME",
            //         is_sales: true,
            //     },
            //     // ... other fee types for Storehub
            // ],
        },
        ext_name: "StoreHub Hubble 1",
        auto_sync: false,
        auto_create_invoice: false,
        grouping: StreamGrouping.ALL,
        // sync_ends_at: "2023-01-10 23:59:59",
        sync_ends_at: null,
        created_at: "2023-01-05 08:45:00",
        updated_at: "2023-01-08 11:20:00",
        deleted_at: null,
        // can_sync: true,
    },
    {
        id: 2,
        flow_provider: {
            id: 2,
            name: "Lazada Ecom",
            short_name: "lazada",
            authentication: FlowAuthType.OAUTH2,
            // GET this from /GET /flow/provider and do mapping
            // fee_types: [
            //     {
            //         id: 11,
            //         name: "Custom Fee 1",
            //         description: "Custom fee for Lazada",
            //         nature: "EXPENSE",
            //         is_sales: false,
            //     },
            //     {
            //         id: 12,
            //         name: "Custom Fee 2",
            //         description: "Another custom fee for Lazada",
            //         nature: "EXPENSE",
            //         is_sales: false,
            //     },
            // ],
        },
        ext_name: "Lazada Shop 1",
        auto_sync: true,
        auto_create_invoice: true,
        grouping: StreamGrouping.PRODUCT,
        sync_ends_at: "2023-02-15 23:59:59",
        created_at: "2023-02-05 14:20:00",
        updated_at: "2023-02-08 18:10:00",
        deleted_at: "2023-02-08 18:10:00",
        // can_sync: true,
    },
    {
        id: 3,
        flow_provider: {
            id: 2,
            name: "Lazada Ecom",
            short_name: "lazada",
            authentication: FlowAuthType.OAUTH2,
        },
        ext_name: "Lazada Shop 2",
        auto_sync: true,
        auto_create_invoice: false,
        grouping: StreamGrouping.ALL,
        sync_ends_at: "2023-02-28 23:59:59",
        created_at: "2023-02-10 09:15:00Z",
        updated_at: "2023-02-12 12:30:00",
        deleted_at: null,
        // can_sync: false,
    },
];

export const flowStreamsPagination = {
    total: 3,
    current_page: 1,
    per_page: 10,
};
